import * as React from "react";
const YouTube = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31 31"
    fill="none"
    {...props}
    aria-label="YouTube logo"
  >
    <g clipPath="url(#a)">
      <path
        fill="red"
        d="M15.5.005c8.56 0 15.5 6.94 15.5 15.5s-6.94 15.5-15.5 15.5S0 24.065 0 15.505 6.94.005 15.5.005"
      />
      <path
        fill="#fff"
        d="M15.494 8.19s-6.533 0-8.173.427c-.878.245-1.6.968-1.846 1.859-.426 1.64-.426 5.035-.426 5.035s0 3.408.426 5.022c.244.89.954 1.6 1.846 1.847 1.652.439 8.173.439 8.173.439s6.545 0 8.185-.426c.89-.245 1.6-.942 1.833-1.846.44-1.627.44-5.023.44-5.023s.011-3.407-.44-5.047a2.58 2.58 0 0 0-1.833-1.833c-1.64-.452-8.185-.452-8.185-.452zm-2.08 4.184 5.436 3.137-5.435 3.124z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .005h31v31H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default YouTube;